import React from 'react'
import InnerHeaderPaySumamry from '../../components/comment/innerHeader/InnnerHeaderIcon'
import Footer from "../../components/footer";
import Header from "../../components/header/index";
import DebitContent from './debitContent/debitContentadd';
// import NetbankingContent from './netbankingcontent/netbankingContent';

const adddebitcard = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeaderPaySumamry title="Add Debit Card "/>
    <DebitContent />
    <Footer />
  </div>
  )
}

export default adddebitcard